import React, { FC, useEffect, useState } from 'react'
import { Dirary } from '../../types/dirary'
import classes from './MultiInputMain.module.scss'
import { useRecoilState } from 'recoil'
import { User, WorkerWithDiary } from '../../types'
import { userState } from '../../states/userState'
import { formatDate } from '../../utils/functions/formatting'
import {
  createDefaultDiary,
  createDefaultDiaryForMulti,
  nullADiaryList,
} from '../../utils/functions/createDefaultDiary'
import { useCheckSendable } from '../../hooks/singleInput/useCheckSendable'
import { calcTotalTimeByDiary } from '../../utils/functions/calcTotalTime'
import { useCheckDiaryList } from '../../hooks/singleInput/useCheckDiaryList'
import WorkersContainer from './workers/WorkersContainer'
import MultiInputHeader from './header/MultiInputHeader'
import MultiInputDetail from './detail/MultiInputDetail'
// const dummyData: Dirary[] = [
//   {
//     id: 1,
//     workerId: 1,
//     workerName: "山田太郎",
//     departmentId: 1,
//     affiliationFactoryId: 1,
//     jobId: 1,
//     workingDate: "2022-01-01",
//     factoryId: 51,
//     constructionId: 1,
//     startTime: "09:00",
//     endTime: "18:00",
//     isBreak: false,
//     totalWorkingTimeByHour: 1.5,
//     totalWorkingTimeByMinute: 0,
//     productNo: "123456",
//     productNo1: 1,
//     productNo2: 1,
//     siteName:
//       "テスト現場名1 テスト現場名1 テスト現場名1 テスト現場名1 テスト現場名1 テスト現場名2",
//     slipNumber: "1234567",
//     processName: "現場代理人専用作業日報",
//     processId: "1024",
//     estimatedTime: 8,
//     workingTimeByHour: 1.5,
//     workingTimeByMinute: 90,
//     comment: "コメント",
//   },
// ];

const MultiInputMain: FC = () => {
  const [user, setUser] = useRecoilState<User>(userState)

  const [workerList, setWorkerList] = useState<WorkerWithDiary[]>(
    user.initialParameters.workersForMultiInput
  )
  const { checkDiaryListSendable } = useCheckSendable()
  //読み込んだ日報リスト
  const [fetchDiaryList, setFetchDiaryList] = useState<Dirary[]>([])
  //作成した日報リスト
  const [diaryList, setDiaryList] = useState<Dirary[]>([])
  //追加・削除・更新日報リスト
  const { addDiaryList, deleteDiaryList, updateDiaryList } = useCheckDiaryList(
    diaryList,
    fetchDiaryList
  )
  //デフォルトの日報（一括）
  const [defaultDiary, setDefaultDiary] = useState<Dirary>(nullADiaryList)
  //デフォルトの製番（一括）
  const [defaultProductNo, setDefaultProductNo] = useState<string>(
    user.initialParameters.productNoForMultiInput!
  )
  //デフォルトの工場（一括）
  const [defaultFactoryNo, setDefaultFactoryNo] = useState<number>(
    user.initialParameters.factoryNoForMultiInput!
  )
  //デフォルトの工事区分（一括）
  const [defaultConstruction, setDefaultCondruction] = useState<number>(
    user.initialParameters.constructionForMultiInput!
  )
  const [defaultProductBno, setDefaultProductBno] = useState<string>(
    user.initialParameters.productBnoForSingleInput!
  )
  //デフォルトの伝票番号（一括）
  const [defaultSlipNumber, setDefaultSlipNumber] = useState<string>(
    user.initialParameters.slipNumberForMultiInput!
  )

  //作業開始日
  const [workingDate, setWorkingDate] = useState({
    obj: new Date(),
    text: formatDate(new Date()),
  })
  //社員情報
  const [workerInfo, setWorkerInfo] = useState<WorkerWithDiary[]>([])
  //作業開始・終了時刻
  const [fromTime, setFromTime] = useState('08:00')
  const [toTime, setToTime] = useState('08:00')
  //休憩有無
  const [hasBreak, setHasBreak] = useState(false)
  //休憩時間
  const [breakTime, setBreakTime] = useState(0)

  //合計時間
  const [totalTime, setTotalTime] = useState({
    hour: 0,
    min: 0,
    text: '00時間00分',
  })
  //送信可否
  const [isSendable, setIsSendable] = useState(false)
  //登録済有無
  const [isEmpty, setIsEmpty] = useState(false)
  useEffect(() => {
    //デフォルトをセット
    setDefaultDiary(
      createDefaultDiaryForMulti(
        workingDate.text,
        fromTime,
        toTime,
        totalTime,
        hasBreak,
        breakTime,
        defaultProductNo,
        defaultProductBno,
        defaultFactoryNo,
        defaultConstruction,
        defaultSlipNumber
      )
    )
    console.log(
      'DEBUG_defaultProductNo_state',
      defaultProductNo,
      defaultProductBno
    )
  }, [
    workerInfo,
    fromTime,
    toTime,
    totalTime,
    // hasBreak,
    breakTime,
    breakTime,
    workingDate,
    defaultProductNo,
    defaultProductBno,
    defaultFactoryNo,
    defaultConstruction,
    defaultSlipNumber,
  ])
  useEffect(() => {
    setDefaultProductNo(user.initialParameters.productNoForMultiInput!)
    setDefaultProductBno(user.initialParameters.productBnoForMultiInput!)
    console.log(
      'DEBUG_defaultProductNo_recoil',
      user.initialParameters.productNoForMultiInput,

      user.initialParameters.productBnoForMultiInput
    )
  }, [
    user.initialParameters.productBnoForMultiInput,
    user.initialParameters.productNoForMultiInput,
  ])
  useEffect(() => {
    setDefaultFactoryNo(user.initialParameters.factoryNoForMultiInput!)
    setDefaultCondruction(user.initialParameters.constructionForMultiInput!)
  }, [
    user.initialParameters.factoryNoForMultiInput,
    user.initialParameters.constructionForMultiInput,
  ])
  useEffect(() => {
    setDefaultSlipNumber(user.initialParameters.slipNumberForMultiInput!)
  }, [user.initialParameters.slipNumberForMultiInput])
  useEffect(() => {
    const res = checkDiaryListSendable(totalTime, diaryList, deleteDiaryList)
    console.log('DEBUG_DAILYLIST_CHANGE', diaryList, '送信可否', res)
    if (res === 0 && isEmpty) {
      setIsSendable(true)
    } else {
      setIsSendable(false)
    }
    if (diaryList.length === 0) {
      setTotalTime({
        hour: 0,
        min: 0,
        text: '00時間00分',
      })

      // setFromTime("08:00");
      setToTime(fromTime)
    } else {
      const { hour, min, text, endTime } = calcTotalTimeByDiary(
        fromTime,
        diaryList,
        hasBreak,
        breakTime
      )
      setTotalTime({ hour, min, text })
      setToTime(endTime)
    }
  }, [diaryList, isEmpty])
  // useEffect(() => {
  //   console.log("fetchDiaryList", fetchDiaryList);
  // }, [fetchDiaryList]);
  return (
    <div className={classes.rootContainer}>
      <div>
        <MultiInputHeader
          setTotalTime={setTotalTime}
          totalTime={totalTime}
          workingDate={workingDate}
          setWorkingDate={setWorkingDate}
          hasBreak={hasBreak}
          setHasBreak={setHasBreak}
          breakTime={breakTime}
          setBreakTime={setBreakTime}
          fromTime={fromTime}
          toTime={toTime}
          setFromTime={setFromTime}
          setToTime={setToTime}
          setFetchDiaryList={setFetchDiaryList}
          diaryList={diaryList}
          setDiaryList={setDiaryList}
        />
        <WorkersContainer
          workingDate={workingDate}
          setWorkerList={setWorkerList}
          workerList={workerList}
          isSendable={isEmpty}
          setIsSendable={setIsEmpty}
          setDefaultFactoryNo={setDefaultFactoryNo}
        />
      </div>
      <div className={classes.hr} />
      <MultiInputDetail
        defaultDiary={defaultDiary}
        diaryList={diaryList}
        // deleteDiaryList={deleteDiaryList}
        // addDiaryList={addDiaryList}
        // updateDiaryList={updateDiaryList}
        setDiaryList={setDiaryList}
        totalTime={totalTime}
        setTotalTime={setTotalTime}
        isSendable={isSendable}
        setWorkerList={setWorkerList}
        workerList={workerList}
      />
    </div>
  )
}

export default MultiInputMain
